import clsx from "clsx";
import {
  Typography,
  TextField,
  Toolbar,
  makeStyles,
  lighten,
  InputAdornment,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import { lang } from "../../../i18nLang";

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    width: "100%",
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.primary.main,
          backgroundColor: lighten(theme.palette.primary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.primary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

interface IProps {
  label?: string;
  inputSize?: "small" | "medium";
  numSelected?: number;
  inputValue?: string;
  onInputChange?: (event) => void;
}

const ToolbarTable = ({
  label,
  inputSize = "small",
  numSelected = 0,
  inputValue,
  onInputChange,
}: IProps) => {
  const classes = useToolbarStyles();
  label = lang("search");

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, classes.highlight)}
          style={{ minHeight: "3rem" }}
        >
          <Typography
            className={classes.title}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {lang("selectedItems", numSelected)}
          </Typography>
        </Toolbar>
      )}
      <Toolbar className={classes.root}>
        <TextField
          id="search"
          type="search"
          value={inputValue}
          placeholder={label}
          margin="normal"
          variant="outlined"
          fullWidth
          size={inputSize}
          onChange={onInputChange}
          onKeyDown={(ev) => ev.stopPropagation()}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Toolbar>
    </>
  );
};

export default ToolbarTable;
